export function buildTripTitle(
  _from: string,
  _to: string,
  _roundTrip: boolean,
): string {
  return "Untitled trip";
}
